import { SettingsGridRow } from "./GenericSettingsGrid";

export const isRowDataDirty = (
  current: SettingsGridRow[],
  initial: SettingsGridRow[]
): boolean => {
  if (current.length !== initial.length) return true;

  return current.some((row, index) => {
    const base = initial[index];
    return (
      row.id !== base.id ||
      row.value !== base.value
    );
  });
};